import { DebugLog } from '../../../../common/js/debug-log';
import { ShouldDisplayVastIconStrategy } from './should-display-vast-icon-strategy';
import {
  AfterVideoLoadedEvent,
  FormatContext,
  ILoadingStrategy
} from './loading-strategy';
import { CtaEndScreenStrategy } from './cta-end-screen-strategy';
import { CustomCloseStrategy } from './custom-close-strategy';
import { iOSWebviewKeepAliveStrategy } from './ios-webview-keep-alive-strategy';

export class LoadingStrategyFactory implements ILoadingStrategy {
  static instance: LoadingStrategyFactory | null = null;

  static getInstance(): LoadingStrategyFactory {
    if (!LoadingStrategyFactory.instance) {
      LoadingStrategyFactory.instance = new LoadingStrategyFactory();
    }

    return LoadingStrategyFactory.instance;
  }

  strategies: ILoadingStrategy[] = [
    new ShouldDisplayVastIconStrategy(),
    new CtaEndScreenStrategy(),
    new CustomCloseStrategy(),
    new iOSWebviewKeepAliveStrategy()
  ];

  isRunnable(): boolean {
    return true;
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    this.loopOnStrategies(formatContext, s => {
      DebugLog.log(
        `LoadingStrategyFactory: alter configuration for ${s.constructor.name}`,
        formatContext as any
      );
      formatContext = s.alterConfiguration(formatContext);
      DebugLog.log(
        `LoadingStrategyFactory: configuration altered for ${s.constructor.name}`,
        formatContext as any
      );
    });

    return formatContext;
  }

  afterVideoLoaded(event: AfterVideoLoadedEvent): AfterVideoLoadedEvent {
    this.loopOnStrategies(event.ctx, s => {
      DebugLog.log(
        `LoadingStrategyFactory: after video loaded for ${s.constructor.name}`,
        event as any
      );
      event = s.afterVideoLoaded(event);
    });
    return event;
  }

  loopOnStrategies(
    formatContext: FormatContext,
    cb: (strategy: ILoadingStrategy) => void
  ): void {
    this.strategies
      .filter(strategy => strategy.isRunnable(formatContext))
      .forEach(cb);
  }
}
